import { accountantIbkApi, baseApi, BillingProductsSlugType, clientIbkApi, selectIsEmpresaDomain, useAppSelector, } from '@ibk/shared-config';
const EMISSOR_CONTACT_REQUEST_URL = '/v1/benefits/contact-request';
const createEmissorContactRequestQuery = (body) => ({
    url: EMISSOR_CONTACT_REQUEST_URL,
    method: 'POST',
    body,
});
const onlyDigits = (value) => value.replace(/\D/g, '');
export function buildEmissorContractAddress(location) {
    return {
        street: location.address,
        number: location.number,
        neighborhood: location.addressLine2 ?? '',
        postalCode: location.zipCode,
        city: location.city,
        state: location.state,
        complement: location.complement ?? null,
    };
}
export const createEmissorBenefitContractQuery = ({ document, address, legacyContractId, }) => ({
    url: '/v1/benefits/contracts',
    method: 'POST',
    body: {
        document: document.replace(/[^A-Za-z0-9]/g, '').toUpperCase(),
        address: {
            street: address.street,
            number: address.number,
            neighborhood: address.neighborhood,
            postalCode: onlyDigits(address.postalCode),
            city: address.city,
            state: address.state,
            complement: address.complement ?? null,
        },
        ...(legacyContractId ? { legacyContractId } : {}),
    },
});
export const clientEmissorBenefitsApi = clientIbkApi.injectEndpoints({
    endpoints: build => ({
        createClientEmissorBenefitContract: build.mutation({
            query: createEmissorBenefitContractQuery,
            transformResponse: (response) => response.result,
            invalidatesTags: ['EmissorContract'],
        }),
        createClientEmissorContactRequest: build.mutation({
            query: createEmissorContactRequestQuery,
        }),
    }),
    overrideExisting: false,
});
export const accountantEmissorBenefitsApi = accountantIbkApi.injectEndpoints({
    endpoints: build => ({
        createAccountantEmissorBenefitContract: build.mutation({
            query: createEmissorBenefitContractQuery,
            transformResponse: (response) => response.result,
            invalidatesTags: ['EmissorContract'],
        }),
        createAccountantEmissorContactRequest: build.mutation({
            query: createEmissorContactRequestQuery,
        }),
    }),
    overrideExisting: false,
});
export const emissorProductTermsApi = baseApi.injectEndpoints({
    endpoints: build => ({
        getEmissorProductTerms: build.query({
            query: () => ({
                url: '/v1/products/management',
                params: { slug: BillingProductsSlugType.VOUCHER_MANAGEMENT_SWAP },
                headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
            }),
            transformResponse: (response) => response.result,
            providesTags: ['ProductManagement'],
        }),
    }),
    overrideExisting: false,
});
export const { useCreateClientEmissorBenefitContractMutation, useCreateClientEmissorContactRequestMutation } = clientEmissorBenefitsApi;
export const { useCreateAccountantEmissorBenefitContractMutation, useCreateAccountantEmissorContactRequestMutation } = accountantEmissorBenefitsApi;
export const { useGetEmissorProductTermsQuery } = emissorProductTermsApi;
export function useCreateEmissorBenefitContractByDomain() {
    const isEmpresaDomain = useAppSelector(selectIsEmpresaDomain);
    const clientMutation = useCreateClientEmissorBenefitContractMutation();
    const accountantMutation = useCreateAccountantEmissorBenefitContractMutation();
    return isEmpresaDomain ? clientMutation : accountantMutation;
}
export function useCreateEmissorContactRequestByDomain() {
    const isEmpresaDomain = useAppSelector(selectIsEmpresaDomain);
    const clientMutation = useCreateClientEmissorContactRequestMutation();
    const accountantMutation = useCreateAccountantEmissorContactRequestMutation();
    return isEmpresaDomain ? clientMutation : accountantMutation;
}
